import EnumDataSource from "utils/enum-data-source.util";
import { InsurancePolicy } from "../../../../../../../../services/types/insurance-policies.type";
import { ManagedCarePlan } from "../../../../../../../../services/types/managed-care-plans.type";

export const EARS_CONFIGURATION_LEFT = "left";
export const EARS_CONFIGURATION_RIGHT = "right";
export const EARS_CONFIGURATION_BOTH = "binaural";

const earConfigurations = {
  [EARS_CONFIGURATION_LEFT]: "Left",
  [EARS_CONFIGURATION_RIGHT]: "Right",
  [EARS_CONFIGURATION_BOTH]: "Binaural",
};
export const EAR_CONFIGURATIONS = new EnumDataSource(earConfigurations);

export const R_OR_T_CONFIGURATION_RECEIVERS = "receivers";
export const R_OR_T_CONFIGURATION_TUBES = "tubes";
export const R_OR_T_CONFIGURATION_NONE = "none";

const receiversOrTubesConfigurations = {
  [R_OR_T_CONFIGURATION_RECEIVERS]: "Receivers",
  [R_OR_T_CONFIGURATION_TUBES]: "Tubes",
  [R_OR_T_CONFIGURATION_NONE]: "None",
};
export const R_OR_T_CONFIGURATIONS = new EnumDataSource(
  receiversOrTubesConfigurations
);

export const D_OR_E_CONFIGURATION_DOMES = "domes";
export const D_OR_E_CONFIGURATION_EARMOLDS = "earmolds";
export const D_OR_E_CONFIGURATION_NONE = "none";

const domesOrEarmoldsConfigurations = {
  [D_OR_E_CONFIGURATION_DOMES]: "Domes",
  [D_OR_E_CONFIGURATION_EARMOLDS]: "Custom Earmolds",
  [D_OR_E_CONFIGURATION_NONE]: "None",
};
export const D_OR_E_CONFIGURATIONS = new EnumDataSource(
  domesOrEarmoldsConfigurations
);

export type OrderConfigurationStepValues = {
  ears: string;
  receiversOrTubes: string;
  domesOrEarmolds: string;
  appointment: any;
  requestSale: string;
  sale: any;
  payment_source_type?: number | null;
  insurance_policy?: InsurancePolicy | null;
  managed_care_plan?: ManagedCarePlan | null;
  productRequestsDeactivateExisting?: boolean;
};

export const SALE_ASSIGN_NEW_SALE = "new";
export const SALE_ASSIGN_NEW_QUOTE = "new_quote";
export const SALE_ASSIGN_PAST_SALE = "existing";
export const SALE_ASSIGN_FUTURE_SALE = "future";
export const SALE_ASSIGN_NO_SALE = "no_sale";

const selectSaleAssignConfigurations = {
  [SALE_ASSIGN_NEW_SALE]: "New Invoice",
  [SALE_ASSIGN_NEW_QUOTE]: "New Quote",
  [SALE_ASSIGN_PAST_SALE]: "Existing Invoice",
  [SALE_ASSIGN_FUTURE_SALE]: "Future Fitting Invoice",
  [SALE_ASSIGN_NO_SALE]: "No Invoice",
};
export const ASSIGN_SALE_CONFIGURATIONS = new EnumDataSource(
  selectSaleAssignConfigurations
);
